function hideWholesaleProducts() {
  console.log("Script Loaded: Waiting for search results...");

  let searchResultsContainer = document.querySelector(".js_search_results");

  if (!searchResultsContainer) {
    console.log("Search container not found. Watching for changes...");
    const observer = new MutationObserver(() => {
      let updatedContainer = document.querySelector(".js_search_results");
      if (updatedContainer) {
        observer.disconnect(); // Stop observing once found
        hideWholesaleProducts(); // Retry now that it exists
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return;
  }

  console.log("Search results container found. Watching for product updates...");

  const observer = new MutationObserver(() => {
    let searchResults = searchResultsContainer.querySelectorAll(".product_info");

    if (searchResults.length === 0) {
      console.log("No products yet. Waiting...");
      return;
    }

    searchResults.forEach((item) => {
      let productNameElement = item.querySelector(".title-product");
      let productName = productNameElement ? productNameElement.innerText : "";

      console.log("Found product:", productName);

      if (productName.toLowerCase().includes("wholesale")) {
        let isWholesaleCustomer = document.body.classList.contains("wholesale_customer");
        console.log("Is wholesale customer?", isWholesaleCustomer);

        if (!isWholesaleCustomer) {
          console.log("Hiding product:", productName);
          item.style.display = "none";
        }
      }
    });
  });

  observer.observe(searchResultsContainer, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", () => {
  hideWholesaleProducts();
});
